import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AppSection />
        <CommentsSection />
        <IndexSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
        <UpdatesSection />
        <CarouselSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}